// Nav entry of Today (shell/nav.ts collects every routes/*.nav.ts; `order` places it in the rail, the tabs and Lisää).
import { defineNav } from '../shell/nav-entry';

export const nav = defineNav({
  id: 'today',
  path: '/',
  icon: 'today',
  group: 'practice',
  phone: 'tab',
  session: true,
  order: 100,
  load: () => import('./Today'),
});
